import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const InventoryRoutes: RouteBundle = {
  domain: 'inventory',
  routes: [
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/container-schemas/',
      handler: EditorRoutes.containerSchemas.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/box-schemas/',
      handler: EditorRoutes.boxSchemas.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/box-schemas/create',
      handler: boxSchemaSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/box-schemas/:boxSchemaId',
      handler: boxSchemaSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/plate-schemas/',
      handler: EditorRoutes.plateSchemas.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/plate-schemas/create',
      handler: plateSchemaSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/plate-schemas/:plateSchemaId',
      handler: plateSchemaSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/location-schemas/',
      handler: EditorRoutes.locationSchemas.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/location-schemas/create',
      handler: locationSchemaSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/location-schemas/:locationSchemaId',
      handler: locationSchemaSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/location-schemas/:locationSchemaId/:section',
      handler: locationSchemaSettings,
    },
  ],
};

function boxSchemaSettings(ownerUrlId: string, registryId: string, boxSchemaId?: string): void {
  EditorRoutes.boxSchemaSettings(ownerUrlId, registryId, boxSchemaId);
}

function plateSchemaSettings(ownerUrlId: string, registryId: string, plateSchemaId?: string): void {
  EditorRoutes.plateSchemaSettings(ownerUrlId, registryId, plateSchemaId);
}

function locationSchemaSettings(
  ownerUrlId: string,
  registryId: string,
  locationSchemaId?: string,
  section?: string
): void {
  EditorRoutes.locationSchemaSettings(ownerUrlId, registryId, locationSchemaId, section);
}
